import React from 'react';
import { Link, navigate } from 'gatsby';

import { Box, Typography } from '@mui/material';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import ContextConsumer from '../PlayerWrapper';

export function BackButton({forceDarkMode}) {
  return (
    <ButtonSmall
      onClick={() => {
        navigate(-1);
      }}
      forceDarkMode={forceDarkMode}
    >
      <Typography variant="button">
        <ArrowBackIosIcon /> Zurück
      </Typography>
    </ButtonSmall>
  );
}

export const ButtonSmall = ({ children, href, onClick, target, rel, forceDarkMode }) => (
  <Button href={href} size="small" onClick={onClick} target={target} rel={rel} forceDarkMode={forceDarkMode}>
    <Typography variant="button">{children}</Typography>
  </Button>
);

export function PlayButton(props) {
  return (
    <ContextConsumer>
      {({ play }) => (
        <Button
          className={props.className}
          size={props.size}
          onClick={() => {
            play(props.src);
          }}
        >
          <Typography variant="button">
            {props.children || 'Abspielen'}
          </Typography>
        </Button>
      )}
    </ContextConsumer>
  );
}

const Button = ({ size, href, onClick, target, rel, className, children, sx, forceDarkMode }) => {
  const sizeClass = size === 'small' ? 'small' : '';

  const buttonSx = {
    display: 'inline-block',
    paddingY: {
      xs: 1,
      md: 2,
    },
    paddingX: {
      xs: 2,
      md: 4,
    },
    marginRight: '5px',

    border: 1,
    borderColor: forceDarkMode ? 'common.white' : 'text.primary',
    boxSizing: 'border-box',
    borderRadius: {
      xs: '14px',
      md: '18px',
    },

    textAlign: 'center',
    textDecoration: 'none',
    color: forceDarkMode ? 'common.white' : 'text.primary',

    backgroundColor: 'transparent',
    cursor: 'pointer',

    '&.small': {
      paddingY: 1,
      paddingX: 4,
      borderRadius: '14px',
      marginBottom: 2,

      svg: {
        height: '19px',
        width: '19px',
        position: 'relative',
        top: '3px',
      },
    },
    ...sx,
  };

  if (href && !href.match(/^mailto|^http|#/)) {
    return (
      <Box
        component={Link}
        className={`${className} ${sizeClass}`}
        sx={buttonSx}
        to={href}
        target={target}
        rel={rel || 'noopener noreferrer'}
      >
        <Typography variant="button">{children}</Typography>
      </Box>
    );
  }
  if (href && href.match(/^#/)) {
    return (
      <Box
        component="button"
        sx={buttonSx}
        className={`${className} ${sizeClass}`}
        onClick={() => {
          navigate(href);
        }}
      >
        <Typography variant="button">{children}</Typography>
      </Box>
    );
  } else if (onClick) {
    return (
      <Box
        component="button"
        sx={buttonSx}
        className={`${className} ${sizeClass}`}
        onClick={onClick}
      >
        <Typography variant="button">{children}</Typography>
      </Box>
    );
  } else {
    return (
      <Box
        component="a"
        sx={buttonSx}
        className={`${className} ${sizeClass}`}
        href={href}
        target={target}
        rel={rel || 'noopener noreferrer'}
      >
        <Typography variant="button">{children}</Typography>
      </Box>
    );
  }
};

export default Button;
